import clsx from "clsx";
import { FunctionComponent } from "react";
import { TransitionStatus } from "react-transition-group";

import DangerouslySetCMSMarkup from "@ui/components/article/DangerouslySetCMSMarkup";
import CaretDownIcon from "@ui/components/icon/CaretDownIcon";
import * as styles from "@ui/components/navigation/LoopNav/LoopNav.css";

const LoopNavCTA: FunctionComponent<{
  open: boolean;
  title: string;
  drawerId: string;
  onClick: () => void;
  subTitle?: string;
  transitionStatus: TransitionStatus;
}> = ({ open, onClick, title, subTitle, transitionStatus, drawerId }) => {
  return (
    <button
      className={styles.cta}
      onClick={onClick}
      aria-expanded={open ? "true" : "false"}
      aria-controls={drawerId}
      aria-label={`${open ? "Expand" : "Collapse"} Special Navigation`}
      title={`${title}${subTitle ? ": " + subTitle : ""}`}
    >
      <span className={styles.titleContainer}>
        <span
          className={clsx(
            styles.title,
            styles.transformTransition,
            (open || !subTitle) && styles.titleOpen,
          )}
        >
          {title}
          {subTitle && <span className={styles.inlineShowTabletPlus}>: </span>}
        </span>
        {subTitle && (
          <DangerouslySetCMSMarkup
            component="span"
            className={clsx(
              styles.subTitle,
              styles.transitionSubtitle,
              open && styles.subTitleOpen,
            )}
            html={subTitle}
          />
        )}
      </span>
      <CaretDownIcon
        className={clsx(
          styles.titleCaret,
          styles.transformTransition,
          transitionStatus === "entering" && styles.rotate,
          transitionStatus === "entered" && styles.rotate,
        )}
      />
    </button>
  );
};

export default LoopNavCTA;
